var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"neo-page",class:{
    'with-tab': _vm.reactiveLayoutWithTab,
    'with-footer': _vm.showFooter,
  }},[_vm._t("default"),(_vm.showFooter)?_c('div',{staticClass:"neo-page-footer"},[_vm._t("footer")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }